export default __webpack_public_path__ + "static/logo-ey-parthenon-2127c0fbc093f47a61d68f5dac910275.svg";